import React, { Fragment } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Address = _ref => {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'single-line' : _ref$appearance,
    postcode = _ref.postcode,
    state = _ref.state,
    streetName = _ref.streetName,
    suburb = _ref.suburb;
  return ___EmotionJSX(Fragment, null, appearance === 'single-line' && ___EmotionJSX("div", null, streetName, ", ", suburb, " ", state, " ", postcode), appearance === 'two-lines' && ___EmotionJSX("div", null, streetName, " ", suburb, " ", state, " ", postcode));
};